import { render, staticRenderFns } from "./PlanPageDetalles.vue?vue&type=template&id=7b520633&"
import script from "./PlanPageDetalles.vue?vue&type=script&lang=js&"
export * from "./PlanPageDetalles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports